/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Banner202,
  PostApiV1Banner400,
  PostApiV1Banner401,
  PostApiV1Banner404,
  PostApiV1Banner500,
  PostApiV1BannerMutationRequest,
  PostApiV1BannerMutationResponse,
} from "../../types/bannerRegistroController/PostApiV1Banner.ts";
import { bannerViewModelSchema } from "../bannerViewModelSchema.ts";
import { eBannerPositionSchema } from "../eBannerPositionSchema.ts";
import { eBannerPrioritySchema } from "../eBannerPrioritySchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1Banner202Schema = z.lazy(
  () => bannerViewModelSchema,
) as unknown as ToZod<PostApiV1Banner202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Banner400Schema =
  z.any() as unknown as ToZod<PostApiV1Banner400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Banner401Schema =
  z.any() as unknown as ToZod<PostApiV1Banner401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1Banner404Schema =
  z.any() as unknown as ToZod<PostApiV1Banner404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Banner500Schema =
  z.any() as unknown as ToZod<PostApiV1Banner500>;

export const postApiV1BannerMutationRequestSchema = z.object({
  CompanyId: z.optional(z.number().int()),
  Title: z.optional(z.string()),
  ShowTitle: z.optional(z.boolean()),
  StartDate: z.optional(z.string().datetime()),
  EndDate: z.optional(z.string().datetime()),
  Position: z.optional(
    z
      .lazy(() => eBannerPositionSchema)
      .describe("1 = Top | 2 = MiddleStart | 3 = MiddleEnd | 4 = Bottom | "),
  ),
  Duration: z.optional(z.number().int()),
  Priority: z.optional(
    z
      .lazy(() => eBannerPrioritySchema)
      .describe(
        "1 = VeryLow | 2 = Low | 3 = Medium | 4 = High | 5 = VeryHigh | ",
      ),
  ),
  Url: z.optional(z.string()),
  General: z.optional(z.boolean()),
  IsMonograph: z.optional(z.boolean()),
  IsMonitor: z.optional(z.boolean()),
  AllowedEnrollmentStatus: z.optional(z.string()),
  Active: z.optional(z.boolean()),
  Image: z.optional(z.instanceof(File)),
  Video: z.optional(z.instanceof(File)),
  ImageMobile: z.optional(z.instanceof(File)),
  VideoMobile: z.optional(z.instanceof(File)),
  ClassStudentIds: z.optional(z.array(z.number().int())),
}) as unknown as ToZod<PostApiV1BannerMutationRequest>;

export const postApiV1BannerMutationResponseSchema = z.lazy(
  () => postApiV1Banner202Schema,
) as unknown as ToZod<PostApiV1BannerMutationResponse>;
